// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + ({"812":"npm.swiper","3674":"vendor_styles"}[chunkId] || chunkId) + ".esm.js";
};